import { z } from 'zod'

export const featureFlagSetSchema = z.object({
  enableGlobalEdits: z.boolean().catch(false),
  enableGrandCanyonErpSync: z.boolean().catch(false),
  isSourcesRouteHidden: z.boolean().catch(false),
  shouldShowReportingFormat: z.boolean().catch(false),
  shouldShowPricingSettings: z.boolean().catch(false),
  showRulesPageForGcOrg: z.boolean().catch(false),
  showContactsPageForGcOrg: z.boolean().catch(false),
  showCategoriesSettings: z.boolean().catch(false),
  isStableCoinsEnabled: z.boolean().catch(false),
  shouldEnableExpandedRoleBasedAccessControl: z.boolean().catch(false),
  shouldShowAdvancedFilters: z.boolean().catch(false),
  enableCustomFields: z.boolean().catch(false),
  isPrincipalMarketAnalysisVisible: z.boolean().catch(false),
  isPrincipalMarketAnalysisEnabled: z.boolean().catch(false),
  isAccountingPageVisible: z.boolean().catch(false),
  erpSyncForReadOnlyUsers: z.boolean().catch(false),
  shouldAutomaticallyTranslate: z.boolean().catch(false),
  enableSplitJournaling: z.boolean().catch(false),
  shouldShowAllLegalEntityText: z.boolean().catch(false),
  swapRollForwardReport: z.boolean().catch(false),
  swapInventorySummaryReport: z.boolean().catch(false),
  swapBalanceReport: z.boolean().catch(false),
  swapFairValueReports: z.boolean().catch(false),
  swapSignificantHoldingsReports: z.boolean().catch(false),
  swapAsc35060Report: z.boolean().catch(false),
  swapJournalEntryReports: z.boolean().catch(false),
  isJournalingReportsEnabled: z.boolean().catch(false),
  swapGainlossSummaryReport: z.boolean().catch(false),
  swapImpairmentReports: z.boolean().catch(false),
  enableRuleBasedPricing: z.boolean().catch(false),
  enableAutomatedInternalTransferDetection: z.boolean().catch(false),
  isSpamTokenAutoSyncEnabled: z.boolean().catch(false),
  isPublicSector: z.boolean().catch(false),
  isAssetTableGroupingEnabled: z.boolean().catch(false),
  isSourceTaggingEnabled: z.boolean().catch(false),
  isCustomErpMappingsEnabled: z.boolean().catch(false),
  isMergeEnabled: z.boolean().catch(true),
  isAuditLogEnabled: z.boolean().catch(false),
  isMultiSourceFilteringEnabled: z.boolean().catch(false),
  isMultiBookEnabled: z.boolean().catch(false),
  shouldShowPaymentsNavItem: z.boolean().catch(false),
  isVoucherWorkflowEnabled: z.boolean().catch(false),
  isPriceLockingEnabled: z.boolean().catch(false),
  shouldDisplayDailyPricesAsReferenceReport: z.boolean().catch(false),
  enableOrgAwareUrls: z.boolean().catch(false),
  enableDataVisibilityUi: z.boolean().catch(false),
  enableBulkTxnEdits: z.boolean().catch(false),
  shouldShowSlugInSelector: z.boolean().catch(false),
  enableBulkWalletUpload: z.boolean().catch(false),
  enableTxnEditReport: z.boolean().catch(false),
  // This is an internal-use only feature flag and a hacky workaround
  // to determine whether feature flags have been loaded.
  areFeatureFlagsLoaded: z.boolean().catch(false),
})

export type FeatureFlagSet = z.infer<typeof featureFlagSetSchema>

/**
 * This object reflects all current flags default values under the LaunchDarkly "TaxBit Accounting" project.
 */
export const defaultFeatureFlagSet = featureFlagSetSchema.parse({})
